import React, { useState } from 'react';
import FullModal from './FullModal';
import { useAuth } from '../../hooks/useAuth';
import { useOrganization } from '../../hooks/useOrganization';
import { InputTextField } from '../Input/InputTextField';
import { Button } from '@mui/material';
import { LoaderSpinner } from './LoaderSpinner';
import { toast } from 'react-hot-toast';
import { toastConfig, successToastConfig, dangerToastConfig } from '../../utils/data';
import { validateNumber } from '../../utils/validations';

const EditOrgCard = ({org, onClose}) => {
    const { name, _users } = org;
  const { user } = useAuth();
  const { fetchOrganizations, updateOrganization } = useOrganization();
  const [orgName, setOrgName] = useState(name || '');
  const [loading, setLoading] = useState(false);

  const teamMembers = _users.length;

  const handleSaveClick = async () => {
        const payload = {
        id: org._id,
        name: orgName
    }
    const res = await updateOrganization(payload);
    if(res.status === 200){
        toast('Organization details updated successfully', successToastConfig);
        fetchOrganizations();
    } else {
        toast('Something went wrong. Please try again', dangerToastConfig);
    }
    fetchOrganizations();
    onClose();
  };

  const handleNameChange = (value) => {
    setOrgName(value);
  };

  return (
    <FullModal onClose={onClose}>

        <InputTextField
            title="Employer group name"
            placeholder='Name'
            value={name}
            onChange={handleNameChange}
        />
        {/* <InputTextField
            title="Number of members"
            placeholder='Number of members'
            value={teamMembers}
            validate={validateNumber}
        /> */}
        <div style={{width: '100%',marginTop: 16}} className="flex-row align-center">
            <Button
                variant="contained" 
                color="primary"
                onClick={handleSaveClick}
            >
                Save
            </Button>
            { loading && <LoaderSpinner style={{marginLeft: 20}} absolute={false} /> }
        </div>
        
    </FullModal>
  );
};

export default EditOrgCard;